var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerElipse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 162,
    viewBox: "0 0 131 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 81.5,
    r: 90.5,
    fill: "url(#paint0_radial_11867_353)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11867_353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5 81.5) rotate(90) scale(90.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.679619,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerElipse1);
export default __webpack_public_path__ + "static/media/bannerElipse1.be6d66ce6a48b7f14ea301d50589651e.svg";
export { ForwardRef as ReactComponent };